import MessagePane from '@v2/components/base/MessagePane';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import About from 'src/components/About';
import { CloseDialog } from 'src/components/base/ConfirmDialog';
import LicenseMessagePane from 'src/components/base/LicenseMessagePane';
import LicenseOverlay from 'src/components/base/LicenseOverlay';
import MainDecorator from 'src/components/base/MainDecorator';
import OverlayProgress, { DefaultLayerHostZ } from 'src/components/base/OverlayProgress';
import Page from 'src/components/base/Page';
import License from 'src/components/License';
import Schedules from 'src/components/Schedules';
import Settings from 'src/components/Settings';
import Debug from 'src/components/Debug';
import Sources from 'src/components/Sources';
import Maintenance from 'src/components/Maintenance'
import HomeContainer from 'src/containers/HomeContainer';
import { registerHistoryService } from 'src/services/sharedRuntime';
import SignIn from "@v2/views/SignIn/SignIn";

const NotificationContainer = observer(({ requestStore }) => {
  if (!requestStore.licenseMessagePane && !requestStore.messagePane) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: DefaultLayerHostZ - 2,
      display: 'flex',
      flexDirection: 'column'
    }}>
      {!!requestStore.licenseMessagePane && (
        <LicenseMessagePane {...requestStore.licenseMessagePane} />
      )}
      {!!requestStore.messagePane && (
        <MessagePane
          onDismiss={() => requestStore.clean()}
          {...requestStore.messagePane}
        />
      )}
    </div>
  );
});

const RootContainer = ({ userStore, requestStore, officeStore, match }) => {
  // const history = useHistory();
  // coachmarkStore.history = history;
  // https://stackoverflow.com/questions/63612097/is-there-a-way-to-use-history-with-hashrouter-with-react-router-v4

  const history = useHistory();
  registerHistoryService(history);

  if (officeStore.maintenanceMode) {
    return (
      <MainDecorator>
        <Maintenance />
      </MainDecorator>
    );
  }

  return (
    <MainDecorator match={match}>
      <NotificationContainer requestStore={requestStore} />
      {!!requestStore.dirtyDialog && <CloseDialog hidden={false} {...requestStore.dirtyDialog} />}
      <Switch>
        <Page path='/about' title='About' component={About} backTo={match.url} />
        {
          !userStore.isAuthorized && !officeStore.initialized
            ? <SignIn />
            : <Switch>
              <Route path='/home' component={HomeContainer} />
              <Page path='/schedules' title='Schedules' component={Schedules} backTo={match.url} />
              <Page path='/settings' title='Settings' component={Settings} backTo={match.url} />
              {userStore.settings?.debugMode && (
                <Page path='/debug' title='Debug' component={Debug} backTo={match.url} />
              )}
              <Page path='/license' title='License' component={License} backTo={match.url} />
              <Page path='/accounts' title='Accounts' component={Sources} backTo={match.url} />
              <Redirect to={`/home`} />
            </Switch>
        }
      </Switch>

      <OverlayProgress task={requestStore.activeTask} />
      {!!requestStore.licenseOverlay && (
        <LicenseOverlay {...requestStore.licenseOverlay} />
      )}
    </MainDecorator>
  );
}

export default inject('userStore', 'requestStore', 'officeStore')(observer(RootContainer));
